import React from 'react';
import ReviewExperience from '../../../../components/Experiences/Form/ReviewExperience';
import { FormStateProvider } from '../../../../components/Experiences/Form/useFormState';
import { useGetOwnerExperienceQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import { useParams } from 'react-router';
import UserRole from '../../../../../shared/AuthRoles';
import LoadingComponent from '../../../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';

const ReviewExperiencePage = () => {
    const { id } = useParams();
    const loggedInUser = UserRole();

    const { data: experience } = useGetOwnerExperienceQuery(
        { owner: loggedInUser?.company, experience: Number(id) },
        {
            skip: !id,
            refetchOnMountOrArgChange: true,
        },
    );

    if (!experience) return <LoadingComponent />;

    return (
        <FormStateProvider experience={experience}>
            <ReviewExperience />
        </FormStateProvider>
    );
};

export default ReviewExperiencePage;
